import { Box, Button, TextField, Typography, Grid } from "@mui/material";
import {
  fontFamilyAll,
  primaryColor,
} from "../../Util/UtilColor";
import bridgeImage from "../../Assets/bridge.jpg";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import { useState } from "react";
import { addressList } from "../../Assets/data";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [formList, setFormList] = useState([]); // store submitted data

  // Sample address data list


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormList([...formList, formData]);

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  const Styles = {
    iconStyle: {
      color: "white",
      marginRight: "8px",
      cursor: "pointer",
    },
    headText: {
      fontSize: "22px",
      fontWeight: "700",
      fontFamily: fontFamilyAll,
      color: "white",
      marginBottom: "10px",
    },
    textFieldStyle: {
      backgroundColor: "rgba(255, 255, 255, 0.4)",
      borderRadius: "5px",
      "& .MuiInputBase-input": {
        color: "white",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
    labelStyle: {
      color: primaryColor,
    },
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${bridgeImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingY: { xs: 5, md: 10 },
        textAlign: "center",
      }}
    >
      {/* Heading */}
      <Box sx={{ mb: 5 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "900",
            fontFamily: fontFamilyAll,
            color: "white",
            fontSize: { xs: "28px", md: "40px" },
          }}
        >
          CONTACT
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "400",
            fontFamily: fontFamilyAll,
            color: "white",
            fontSize: { xs: "18px", md: "24px" },
          }}
        >
          YOU KNOW YOU CAN ASK US EVERYTHING
        </Typography>
      </Box>

      {/* Info Section - Address List */}
      <Grid
        container
        spacing={4}
        sx={{
          px: { xs: 2, sm: 5, md: 10 },
          mb: 5,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        {addressList.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Typography sx={Styles.headText}>{item.title}</Typography>
            {item.icons ? (
              <Box>
                <FacebookIcon sx={Styles.iconStyle} />
                <InstagramIcon sx={Styles.iconStyle} />
                <XIcon sx={Styles.iconStyle} />
              </Box>
            ) : (
              <Typography sx={{ color: "white", fontSize: "18px" }}>
                {item.value}
              </Typography>
            )}
          </Grid>
        ))}
      </Grid>

      {/* Form */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          px: { xs: 2, sm: 5, md: 15 },
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{ width: "100%", maxWidth: "600px" }}
        >
          <TextField
            sx={Styles.textFieldStyle}
            InputLabelProps={{ style: Styles.labelStyle }}
            fullWidth
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            sx={Styles.textFieldStyle}
            InputLabelProps={{ style: Styles.labelStyle }}
            fullWidth
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            sx={Styles.textFieldStyle}
            InputLabelProps={{ style: Styles.labelStyle }}
            fullWidth
            label="Email Address"
            name="email"
            type="email"
            variant="outlined"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            sx={Styles.textFieldStyle}
            InputLabelProps={{ style: Styles.labelStyle }}
            fullWidth
            label="Subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            sx={Styles.textFieldStyle}
            InputLabelProps={{ style: Styles.labelStyle }}
            fullWidth
            label="Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={4}
            required
          />
          <Box sx={{ mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              color="error"
              sx={{
                py: 1.5,
                fontFamily: fontFamilyAll,
                width: "100%",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Send Mail
            </Button>
          </Box>
        </form>
      </Box>

  
    </Box>
  );
}
